
import { usePermissions } from '@/contexts/unified-permissions';

export type SubscriptionStatus = 'loading' | 'subscribed' | 'not_subscribed' | 'error';

export const useSubscriptionStatus = () => {
  const { 
    isPremium, 
    permissionsStatus, 
    isRefreshing, 
    error, 
    refreshPermissions,
    subscriptionSource 
  } = usePermissions();



  return {
    isSubscribed: isPremium,
    isLoading: permissionsStatus === 'loading',
    hasError: permissionsStatus === 'error',
    errorMessage: error,
    checkAttempted: permissionsStatus !== 'loading',
    isRefreshing,
    refreshStatus: refreshPermissions,
    source: subscriptionSource
  };
};
